const pluralize = (count: number, singular: string, plural?: string) =>
  count === 1 ? singular : plural || `${singular}s`

export default pluralize
